import Vue from 'vue'
import Vuex from 'vuex'
import TIM from 'tim-js-sdk'
import TIMUploadPlugin from 'tim-upload-plugin'
import { imMsgObjToLocalMsgObj } from '../plugins/helper'
import axios from '../plugins/axios'
let TIMOptions = {
  SDKAppID: 1400605468, // 接入时需要将 0 替换为您的云通信应用的 SDKAppID，类型为 Number
  secret: `333326573f3acd8ad905b85bc6fcd4ba814a7d128c5ce7b0d567199023f96d88`,
}
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    appName: '雪王建店管理系统',
    workTeams: [],
    provinces: [],
    roles: [],
    userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
    userTypes: {
      admin: [],
      decorate: [],
    },
    detail: {
      show: false,
    },
    JDETemplates: [],
    im: {
      instance: null,
      clients: [],
      showNoticeBadge: false,
    },
    productCategory: [],
    storeGroups: [],
    UnHandleComplainSuggest:0,
    orderState: {
      1: '待确认',
      2: '待付款',
      // 2: '确认中',
      3: '付款中',
      4: '已付款',
      // 4: '已确认',
      5: '待发货',
      6: '发货中',
      7: '已收货',
      8: '已完成',
      9: '申请退款',
      10: '退款中',
      11: '已退款',
      12: '已取消',
    },
    presaleOrderState: {
      1: '未开始',
      2: '进行中',
      3: '预售失败',
      4: '预售成功',
      5: '已取消',
    },
    selectOption: {
      brands: [],
      suppliers: [],
    },
    notifyDataString: '',
    menus: [],
    tabMenu: localStorage.getItem('tabMenu') !== 'false',
  },
  mutations: {
    setProvinces(state, payload) {
      state.provinces = payload
    },
    setRoles(state, payload) {
      state.roles = payload.map(item => ({
        value: item.key,
        label: item.value,
      }))
    },
    setUser(state, obj) {
      state.user = obj
    },
    setToken(state, string) {
      sessionStorage.token = string
      state.token = string
    },
    setJDETemplates(state, list) {
      state.JDETemplates = list
    },
    setProductCategory(state, list) {
      state.productCategory = list
    },
    setStoreGroups(state, list) {
      state.storeGroups = list
    },
    setDetailShow(state, show) {
      state.show = show
    },
    setWorkTeams(state, payload) {
      state.workTeams = payload
    },
    setSelectOptions({ selectOption }, { label, value }) {
      selectOption[label] = value
    },
    setUserInfo(state, payload) {
      localStorage.userInfo = JSON.stringify(payload)
      state.userInfo = payload
    },
    setUnread() {
      axios.post('/complainSuggest/totalUnRead').then(data => {//获取投诉建议未处理数量
        this.state.UnHandleComplainSuggest=data.num
        })
    },
    setUserTypes(state, { scope, value }) {
      state.userTypes[scope] = value.map(item => ({
        value: item.key,
        label: item.value,
      }))
    },
    setNotifyData(state, payload) {
      state.notifyDataString = payload
    },
    setMenus(state, list) {
      state.menus = list
    },
    setTabMenu(state, value) {
      Vue.set(state, 'tabMenu', value)
      localStorage.setItem('tabMenu', value)
    },
    initIM(state, payload) {
      state.im.instance = TIM.create(TIMOptions)
      state.im.instance.setLogLevel(
        process.env.NODE_ENV === 'development' ? 0 : 1
      )
      state.im.instance.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
      state.im.instance.on(TIM.EVENT.SDK_READY, function(event) {
        console.log('TIM.EVENT.SDK_READY', event)
      })
      state.im.instance.on(TIM.EVENT.MESSAGE_RECEIVED, function(event) {
        event.data.forEach(msg => {
          console.log('收到消息', msg)
          const localMsg = imMsgObjToLocalMsgObj(msg)
          const target = state.im.clients.find(item => item.userId === msg.from)
          if (target) {
            target.messages.push(localMsg)
          } else {
            axios.get(`/im/getName/${msg.from}`).then(data => {
              state.im.clients.push({
                userId: msg.from,
                userName: data,
                messages: [localMsg],
              })
            })
          }
          this.commit('setImNoticeBadgeState', true)
          document.querySelector('#im-audio').play()
        })
      })
      state.im.instance.login({
        userID: payload.userId,
        userSig: payload.token,
      })
    },
    setImNoticeBadgeState(state, payload) {
      state.im.showNoticeBadge = payload
    },
  },
})
